var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.showLoading),expression:"showLoading"}],attrs:{"id":"preview"}},[_c('div',{staticClass:"chapter",attrs:{"id":"chapter"},on:{"click":_vm.handleSael}},[(_vm.show)?_c('img',{attrs:{"src":_vm.chapter_,"alt":""}}):_vm._e()]),_c('div',{attrs:{"id":"itmes"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }